import { Modal } from '../../../../../core/components/templates/Modal';
import CardScore from '../../CardScore';

export function PopUpModal({ isOpen, onClose, score }: any) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className='flex flex-col items-center justify-center gap-4 bg-color-transparent'
      style={{ boxShadow: 'none' }}
    >
      <div className='w-[250px]'>
        <CardScore score={score} onClose={onClose} />
      </div>
    </Modal>
  );
}
